import { TestProjectRunResults } from '../types';

export enum BaselineCoverageCategory {
    NOT_AVAILABLE = 'not_available',
    EMPTY_BASELINES = 'empty_baselines',
    LOW_COVERAGE = 'low_coverage',
    HIGH_COVERAGE = 'high_coverage'
}

export class TestProjectUtils {
    static calculateResultVsBaseline(run: TestProjectRunResults): number {
        const totalTopics = run.topics.length;
        const totalPassed = run.topics.filter(t => t.baselineFuzzy <= t.fuzzy).length;
        const successPercent = (totalPassed / totalTopics) * 100;

        return Math.round(successPercent + Number.EPSILON);
    }

    static getRoundedBaselineCoverage(coverage?: number | null): number | null {
        if (coverage == null) {
            return null;
        }

        return Math.round(coverage + Number.EPSILON);
    }

    static getBaselineCoverageCategory(coverage?: number | null): BaselineCoverageCategory {
        const roundedCoverage = this.getRoundedBaselineCoverage(coverage);

        if (roundedCoverage == null) {
            return BaselineCoverageCategory.NOT_AVAILABLE;
        }

        if (roundedCoverage === 0) {
            return BaselineCoverageCategory.EMPTY_BASELINES;
        }

        if (roundedCoverage < 80) {
            return BaselineCoverageCategory.LOW_COVERAGE;
        }

        return BaselineCoverageCategory.HIGH_COVERAGE;
    }
}
